import { useEffect } from "react";
import { useLoaderData, useNavigate } from "react-router-dom";
import { useGlobal } from "../../components/GlobalProviderLayout";
import { IToast, OPEN_TOAST, RESET_EMAIL_SUBMITTED } from "../../components/GlobalProviderLayout/GlobalProviderLayoutModel";
import { config } from "../../utils/config";
import { doFetch } from "../../utils/doFetch";
import { MyProfile } from "./MyProfile";
import { MyProfileData } from "./MyProfileData";

export const myProfileRouteLoader = async ({ request }: { request: any }) => {
  return doFetch(`my-profile`, { signal: request.signal }, true, true);
}

export const MyProfileRoute = () => {
  const global = useGlobal();
  const navigate = useNavigate();
  const data = useLoaderData() as MyProfileData;

  useEffect(() => {
    if (global.state.emailSubmitted) {
      const payload: IToast = {
        msg: "We've sent a verification email to the address you provided. It may take a few minutes to arrive.",
        closeTime: 0,
        severity: "info",
      };

      global.dispatch({ type: OPEN_TOAST, payload });
      global.dispatch({ type: RESET_EMAIL_SUBMITTED });
    }
  }, []);

  return <MyProfile
    data={data}
    onUpdateSmbPassword={() => { window.location.href = `${config.oidcAuthority}/user/changesmbpassword`; }}
    onUpdateIvrPassword={() => { window.location.href = `${config.oidcAuthority}/user/changeivrpassword`;; }}
    onUpdateSecurityQuestion={() => navigate('/security-question')}
    onUpdateAddress={() => { navigate('/contact-address') }}
    onUpdatePhone={() => { navigate('/contact-phone') }}
    onUpdateEmail={() => { navigate('/contact-email') }}
    onSeeMoreRatings={() => navigate('/ratings')}
    onSeeMoreCapabilities={() => navigate('/capabilities')}
    onSeeMoreSuspensionsRestrictions={() => navigate('/suspensions')}
    onSeeMoreTrades={() => navigate('/trades')}
    onSeeMoreTickets={() => navigate('/tickets')}
    onViewMyUsageHistory={() => navigate('/usage')
    }
  />;
}